module.exports = __webpack_public_path__ + "img/ic-devices-inactive.e337ef4e.svg";